import AppCard from 'presentation/components/shared/card/AppCard';
import SidebarMenuList from 'presentation/components/shared/sidebar/menu/SidebarMenuList';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import recommendationsIcon from 'assets/img/icons/nav/recommendations-3d.png';
import myOrdersIcon from 'assets/img/icons/nav/applications-3d.png';
import myActivesIcon from 'assets/img/icons/nav/assets-3d.png';
import strategiesIcon from 'assets/img/icons/nav/strategies-3d.png';

const ActivesNavSidebarContainer: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const location = useLocation();

  return (
    <AppCard display="flex" flexDir="column" w="100%">
      <SidebarMenuList
        items={[
          {
            onClick: () => {
              navigate(AppRoute.strategies);
            },
            text: t('strategiesTitle'),
            icon: strategiesIcon,
            iconSize: '38px',
            isActive: location.pathname.startsWith(AppRoute.strategies),
          },
          {
            onClick: () => {
              navigate(AppRoute.recommendations);
            },
            text: t('myRecommendations'),
            icon: recommendationsIcon,
            iconSize: '38px',
            isActive: location.pathname.startsWith(AppRoute.recommendations),
          },
          {
            onClick: () => {
              navigate(AppRoute.peDeals);
            },
            text: t('myDealsLabel'),
            icon: myActivesIcon,
            iconSize: '38px',
            isActive: location.pathname.startsWith(AppRoute.peDeals),
          },
          {
            onClick: () => {
              navigate(AppRoute.peSelfOrders);
            },
            text: t('myOrdersLabel'),
            icon: myOrdersIcon,
            iconSize: '38px',
            isActive: location.pathname.startsWith(AppRoute.peSelfOrders),
          },
        ]}
      />
    </AppCard>
  );
};

export default ActivesNavSidebarContainer;
